import React, { Component } from "react";
import FacebookLoginBtn from "react-facebook-login";
import { make_request, after_auth } from "../Utils/Utils";

export default class LoginFacebook extends Component {
  state = {
    auth: false,
    user: { name: "", picture: "", email: "", birthday: "" , uid: "", provider: 'facebook'},
  };

  register = () => {};

  componentClicked = () => {};

  responseFacebook = async(response) => {
    // console.log(response);
    if (response.status !== "unknown" && response.status !== "not_authorized") {
      this.setState({
        auth: true,
        user: {
          email: response.email,
          name: response.name,
          birthday: response.birthday,
          picture: response.picture.data.url,
          uid: response.id,
          provider: 'facebook'
        },
      });
      const { user } = this.state;
      let edition_id = this.props.editionId
      let responseJson = await make_request({
        path: "auth/facebook",
        method: "POST",
        body: {user, edition_id}
      });
      if (responseJson) {
        if (responseJson.status === "success") {
          // console.log(responseJson);
          after_auth(responseJson)
        } else {
          // console.log("responseJson => " + JSON.stringify(responseJson));
          alert(responseJson.errors[0]);
        }
      }
    }
  };

  render() {
    let facebookData;
    facebookData = (
          <FacebookLoginBtn
            appId={process.env.REACT_APP_FACEBOOK_APP_ID}
            autoLoad={false}
            fields="name,email,picture"
            onClick={this.componentClicked}
            callback={this.responseFacebook}
            isMobile={false}
          />
        );
    return facebookData;
  }
}
